import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import PropTypes from 'prop-types'

import {
  BedTypeBase,
  BedsWrapper,
  BedWrapper,
  IconWrapper,
  Separator,
  Title,
  BedDescription,
} from './styles'
import IconDoubleBed from 'client/icons/beds/Double'
import IconSingleBed from 'client/icons/beds/Single'
import IconSofaBed from 'client/icons/beds/SofaBed'
import IconBunkBed from 'client/icons/beds/BunkBed'
import { DESIGN_ICON_LIMIT, SMALL_SIZE, ICON_MEDIUM_SIZE, ICON_SMALL_SIZE } from './constants'

const BedType = ({ beds = [], size = SMALL_SIZE, title = true, hideIcons = false }) => {
  if (beds.length === 0) {
    return null
  }

  function getBedIcon(type) {
    const finalSize = size === SMALL_SIZE ? ICON_SMALL_SIZE : ICON_MEDIUM_SIZE
    const BED_TYPES = {
      FullBed: <IconDoubleBed size={finalSize} />,
      QueenBed: <IconDoubleBed size={finalSize} />,
      KingBed: <IconDoubleBed size={finalSize} />,
      MurphyBed: <IconDoubleBed size={finalSize} />,
      WaterBed: <IconDoubleBed size={finalSize} />,
      TwinBed: <IconSingleBed size={finalSize} />,
      TwinXLBed: <IconSingleBed size={finalSize} />,
      SofaBed: <IconSofaBed size={finalSize} />,
      FutonBed: <IconSofaBed size={finalSize} />,
      BunkBed: <IconBunkBed size={finalSize} />,
      TrundleBed: <IconBunkBed size={finalSize} />,
    }

    return BED_TYPES[type]
  }

  return (
    <BedTypeBase size={size}>
      {title ? (
        <Title size={size}>
          <FormattedMessage {...messages.beds} tagName="p" />
        </Title>
      ) : null}
      <BedsWrapper>
        {beds.map((bed, index) => {
          const items = [...Array(bed?.quantity).keys()]

          return (
            <BedWrapper key={`bedtype-${bed?.type}`}>
              {!hideIcons && (
                <IconWrapper>
                  {items.length <= DESIGN_ICON_LIMIT
                    ? items.map(item => (
                        <Fragment key={`icon-${item}`}>{getBedIcon(bed?.type)}</Fragment>
                      ))
                    : getBedIcon(bed?.type)}
                </IconWrapper>
              )}
              <BedDescription>{`${bed?.quantity} ${bed?.description}`}</BedDescription>
              {index + 1 < beds.length ? <Separator>·</Separator> : null}
            </BedWrapper>
          )
        })}
      </BedsWrapper>
    </BedTypeBase>
  )
}

BedType.propTypes = {
  size: PropTypes.string,
  beds: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      quantity: PropTypes.number,
    })
  ),
  title: PropTypes.bool,
  hideIcons: PropTypes.bool,
}

export default BedType
